import { createRouter, createWebHistory, isNavigationFailure } from 'vue-router';
import { useGTag } from '~/composables/useGTag';
import { routes } from '~/routes';
import { useModelsStore, useUserStore } from '~/stores';

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    linkActiveClass: 'router-link-active',
    linkExactActiveClass: 'router-link-exact-active',

    scrollBehavior(_to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

// Error handling
router.onError((error, _to, _from) => {
    console.error('Router error:', error);

    // Handle chunk loading errors by reloading the page
    if (error.name === 'ChunkLoadError') {
        window.location.reload();
    }
});

{
    let gtag: ReturnType<typeof useGTag> | undefined;
    let modelsStore: ReturnType<typeof useModelsStore> | undefined;
    let userStore: ReturnType<typeof useUserStore> | undefined;

    router.afterEach((to, from, failure) => {
        try {
            if (isNavigationFailure(failure)) return;

            if (!(typeof to.name === 'string')) return;

            gtag ??= useGTag();
            modelsStore ??= useModelsStore();
            userStore ??= useUserStore();

            if (userStore.data && !sessionStorage.getItem('panel_session_start')) {
                gtag.trackEvent('panel_session_start', {
                    account_age_days: Math.ceil((new Date().getTime() - new Date(userStore.data.createdAt).getTime()) / (1000 * 60 * 60 * 24)),
                });

                sessionStorage.setItem('panel_session_start', '1');
            }

            if (to.name.startsWith('server.') && modelsStore.server) {
                gtag.trackEvent(
                    'panel_tab_opened',
                    {
                        tab_name: to.name,
                        server_id: modelsStore.server.id,
                        server_whmcs_id: modelsStore.server.externalId,
                        game_type: modelsStore.server.egg.name,
                        plan_cpu: modelsStore.server.limits?.cpu,
                        plan_memory: modelsStore.server?.limits?.memory,
                        plan_disk: modelsStore.server?.limits?.disk,
                    },
                    to.name,
                );
            }
        } catch (err) {
            console.error('Failed to track page view event:', err);
        }
    });
}

export default router;
